import { ChipsField } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { FragmentTagGroupsSelector } from './FragmentTagGroupsSelector';

export function FragmentsTagInput() {
  const { $t } = useIntl();

  return (
    <ChipsField
      name="tags"
      label={$t({ id: 'fragments.props.tags', defaultMessage: 'Tags' })}
      placeholder={$t({
        id: 'fragments.form.tags.placeholder',
        defaultMessage: 'Agregar tag',
      })}
      fullWidth
      helperText={<FragmentTagGroupsSelector />}
    />
  );
}
